import { Maybe, ObjectType } from '@csp/csp-common-model';
import { AssessmentAggregateGroupResultFieldsV1, AssessmentOutcomeInV1 } from '@csp/dmdp-api-assessment-dto';
import { AssessmentAlgorithmResult } from '../model/AssessmentAlgorithmResult';
import { AssessmentCustomStatusType } from '../model/AssessmentCustomStatusType';
import { AssessmentOutcomeKey } from '../model/AssessmentOutcomeKey';

const getOutcomeResultValue = (
  isOkResult: Maybe<boolean>,
  additionalOutput?: ObjectType,
): Partial<AssessmentOutcomeInV1> => {
  let value: AssessmentAlgorithmResult = AssessmentAlgorithmResult.ALGORITHM_RESULT_COMPLETED;

  if (isOkResult !== undefined) {
    value = isOkResult
      ? AssessmentAlgorithmResult.ALGORITHM_RESULT_OK
      : AssessmentAlgorithmResult.ALGORITHM_RESULT_NOT_OK;
  }

  const output = JSON.stringify({
    ...additionalOutput,
    ...(value ? { result: value } : undefined),
  });

  return {
    output,
    value,
  };
};

/**
 * TODO[!DeviceSquad!]: remove when back-end has fixed the issue with the customStatusValue field in the assessment
 * aggregate query api.
 *
 * The back-end is returning a string with the status other statuses separated by a comma in the customStatusValue
 * field from the aggregate query api.
 *
 * Example:
 * ```typescript
 *  const customStatusType = 'VIEW_STATUS,ASSESSMENT_CONSEQUENCE_ACTIVITY_CARD_STATUS';
 *  const customStatusValue = '100_VIEWED,001_NOT_VIEWED';
 *
 *  const finalStatusAfterSplit = '100_VIEWED';
 * ```
 */
const getValueFromKey = (keyString: Maybe<string>, valueString: Maybe<string>, key: string): Maybe<string> => {
  const keys = keyString?.split(',');
  const indexOfKey = keys?.findIndex(k => k === key);
  const values = valueString?.split(',') ?? [];
  return indexOfKey !== undefined ? values[indexOfKey] : undefined;
};

const getStatusValueFromKey = (
  fields: AssessmentAggregateGroupResultFieldsV1,
  key: AssessmentCustomStatusType,
): Maybe<string> => getValueFromKey(fields.customStatusType, fields.customStatusValue, key);

const getOutcomeValueFromKey = (
  fields: AssessmentAggregateGroupResultFieldsV1,
  key: AssessmentOutcomeKey,
): Maybe<string> => getValueFromKey(fields.outcomeKey, fields.outcomeValue, key);

export const RpmAssessmentUtil = {
  getOutcomeResultValue,
  getStatusValueFromKey,
  getOutcomeValueFromKey,
};
